import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DiscoveryInHomeComponent } from './discovery-in-home.component';
import { CSSLoaderModule } from '../css-loaders/css-loader.module';



@NgModule({
  declarations: [
    DiscoveryInHomeComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    CSSLoaderModule
  ],
  exports: [
    DiscoveryInHomeComponent
  ],
})
export class DiscoveryInHomeModule { }
